import script from "./Contact-Us.vue?vue&type=script&setup=true&lang=js"
export * from "./Contact-Us.vue?vue&type=script&setup=true&lang=js"

import "./Contact-Us.vue?vue&type=style&index=0&id=585d11fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585d11fc"]])

export default __exports__